angular.module('NiacsProjectApp.controllers-step3', [
])
.controller('EvaluateCtrl',['$scope','$routeParams','$filter','$log','ProjectService','AutoSaveService','DialogService',
    function($scope,$routeParams,$filter,$log,ProjectService,AutoSaveService,DialogService) {
        $scope.overviewVisit = function(context) {
            // calls visit to open the first unevaluated objective on the evaluate view.
            var objectives = niacs.collectObjectives(context,false),
                unevaluatedObjectiveUniqueId = null,i,empty;
            for(i = 0; i < objectives.length; i++) {
                empty = niacs.isEmptyObject(objectives[i].evaluate);
                if(empty || !unevaluatedObjectiveUniqueId) {
                    unevaluatedObjectiveUniqueId = "eval.obj."+objectives[i].id;
                    if(empty) {
                        break;
                    }
                }
            }
            $scope.visit('evaluate','eval.objectives.'+context.id,unevaluatedObjectiveUniqueId);
        };
        // add-remove statement support (Step 3)
        $scope.saveStatement = function(objective,statement) {
            if(niacs.isEmpty(statement.description)) {
                niacs.info("saveStatement with empty description, ignoring.");
                AutoSaveService.saveComplete(true);
                return;
            }
            niacs.info("saveStatement.objective",objective);
            niacs.info("saveStatement.statement",statement);
            if(!statement.id){
                if(!objective.evaluate) {
                    objective.evaluate = {}; // shouldn't happen.
                }
                var type = statement.type;
                delete statement.type;
                statement.id = niacs.guid();
                if(type == 'challenge') {
                    if(!objective.evaluate.challenges) {
                        objective.evaluate.challenges = [];
                    }
                    objective.evaluate.challenges.push(statement);
                } else if (type == 'opportunity') {
                    if(!objective.evaluate.opportunities) {
                        objective.evaluate.opportunities = [];
                    }
                    objective.evaluate.opportunities.push(statement);
                } else {
                    $log.error("unknown statement type",type,statement);
                }
            } // otherwise data already bound
            ProjectService.save();
        };

        $scope.removeStatement = function(objective,statement,type) {
            niacs.info("removeStatement.objective",objective);
            niacs.info("removeStatement.statement",type,statement);
              var dialogContents = {
                message: 'Are you sure you want to remove this '+(type == 'challenge' ? 'Challenge' : 'Opportunity')+'?',
                warning: 'This cannot be undone.',
                okText: 'Yes, remove it',
                cancelText: 'No, keep it',
                conditions: []
              };
              DialogService.safe(dialogContents).then(function() {
                niacs.info('user confirmed deletion of statement.');
                AutoSaveService.startSaving();
                if(type == 'challenge') {
                    if(!niacs.removeById(objective.evaluate.challenges,statement.id)) {
                        $log.error("unable to find statement to remove", statement);
                    }
                } else if (type == 'opportunity') {
                    if(!niacs.removeById(objective.evaluate.opportunities,statement.id)) {
                        $log.error("unable to find statement to remove", statement);
                    }
                }
                ProjectService.save();
              });
        };

        $scope.saveObjective = function(unit,goal,objective) {
            niacs.info("saveObjective.unit",unit);
            niacs.info("saveObjective.goal",goal);
            niacs.info("saveObjective.objective",objective);
            ProjectService.save();
        };

        function isEvaluated(objective) {
            return !niacs.isEmptyObject(objective.evaluate);
        }
        function checkEvaluationStatus() {
            var total = 0;
            var evaluated = 0;
            angular.forEach($scope.project.goals,function(goal) {
                if(goal.objectives) {
                    total += goal.objectives.length;
                    angular.forEach(goal.objectives,function(objective){
                        if(isEvaluated(objective)) {
                            evaluated++;
                        }
                    });
                }

            });
            angular.forEach($scope.project.units,function(unit){
                angular.forEach(unit.goals,function(goal){
                    if(goal.objectives) {
                        total += goal.objectives.length;
                        angular.forEach(goal.objectives,function(objective){
                            if(isEvaluated(objective)) {
                                evaluated++;
                            }
                        });
                    }
                });
            });
            $scope.totalObjectives = total;
            $scope.evaluatedObjectives = evaluated;
        }
        function getContexts() {
            var project = $scope.project,contexts,i,inflate;
            if(project && project.$vuln_region && project.$vuln_region.$units) {
                project.$noObjectives = niacs.collectObjectives(project,true) === 0;
                inflate = $filter('inflate');
                // project.cistatements | inflate:project.$vuln_region.$cistatements
                project.$cistatements_inflated = inflate(project.cistatements,project.$vuln_region.$cistatements);
                //unit in project.units | inflate:project.$vuln_region.$units
                contexts = [/*project*/].concat(inflate(project.units,project.$vuln_region.$units)).filter(function(c){
                    return c !== undefined;
                });
                //context.cistatements | inflate:((context.id==project.id)?project.$vuln_region.$cistatements:context.$cistatements)
                var unitLabel = $filter('unitLabel'),
                    objectEvaluateBanner = $filter('objectEvaluateBanner'),
                    step3Completeness = $filter('step3Completeness');
                contexts.forEach(function(c) {
                    c.$cistatements_inflated = inflate(c.cistatements,c.$cistatements);
                    //goal in context.goals | inflate:project.goals:true
                    c.$goals_inflated = inflate(c.goals,project.goals,true);
                    // {{context | unitLabel:project}} Objectives
                    c.$s3_unitLabel = unitLabel(c,project);
                    // {{context | objectEvaluateBanner:false}}
                    c.$s3_banner = objectEvaluateBanner(c,false);
                    // {{context | step3Completeness:false}}
                    c.$s3_status = step3Completeness(c,false);
                });
                if($scope.contexts && $scope.contexts.length) {
                    for(i = 0; i < contexts.length; i++) {
                        angular.extend($scope.contexts[i], contexts[i]);
                    }
                } else {
                    $scope.contexts = contexts;
                }
            }
        }

        $scope.$watch('project.$vuln_region.$units',getContexts);
        $scope.$watch('project.$updateCount',getContexts);
        ProjectService.get($routeParams,'EvaluateCtrl',function(p){
            $scope.project = p;
            $scope.$watch('project.goals',checkEvaluationStatus);
            $scope.$watch('project.units',checkEvaluationStatus);
        });
}]);
